import Dispatch from '../core/Dispatch';
import axios from 'axios';
import { stringify } from 'qs';
import Config from '../core/Config';

import get from 'lodash/get';

import * as eventKeys from './events';

let tweenScrollTopTimeout;

export const tweenScrollTop = (scrollTop, duration = 2, ease = 'Cubic.easeOut') => {
    if (tweenScrollTopTimeout) {
        clearTimeout(tweenScrollTopTimeout);
    }
    // Using a timeout to dispatch the PROGRAMMATIC_SCROLL_END event, because the tween might be interrupted if the user starts scrolling
    tweenScrollTopTimeout = setTimeout(() => {
        clearTimeout(tweenScrollTopTimeout);
        tweenScrollTopTimeout = null;
        Dispatch.emit(eventKeys.PROGRAMMATIC_SCROLL_END);
    }, duration * 1000);
    TweenMax.to(window, duration, {
        scrollTo: scrollTop,
        ease,
        onStart: () => {
            Dispatch.emit(eventKeys.PROGRAMMATIC_SCROLL_START);
        }
    });
};


const i18n = JSON.parse(Config.get('i18n'));
export const t = (key, vars = {}) => {
    let value = get(i18n, key, key);
    Object.keys(vars).forEach(name => {
        const pattern = `{${name}}`;
        value = value.replace(new RegExp(pattern, 'g'), vars[name]);
    });
    return value;
};


/**
 * Returns an Axios instance with a sensible, default configuration
 * @param config
 * @returns {AxiosInstance}
 */
const { csrfTokenValue } = window;
export const getAxios = (config = {}) => axios.create({
    baseURL: window.location.href || '/',
    headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrfTokenValue
    },
    transformRequest: [(data) => stringify(data)],
    ...config
});


/**
 * Convert newlines to <br/>
 *
 * @param str
 */
export const nl2br = str => str ? str.replace(/(?:\r\n|\r|\n|\\r\\n|\\r|\\n)/g, '<br />') : null;

/**
 * Trigger a native event on a generic node/target
 * because we kicked jQuery to the curb
 *
 * @param event
 * @param target
 * @param eventOpts
 */
export const triggerNativeEvent = (event, target, eventOpts = {}) => {
    target = target || window;
    if (typeof (Event) === 'function') {
        // modern browsers
        target.dispatchEvent(new Event(event, { bubbles: true, cancelable: false, ...eventOpts }));
    } else {
        // for IE and other old browsers
        // causes deprecation warning on modern browsers
        const e = target.document.createEvent('UIEvents');
        const { bubbles = true, cancelable = false, detail = 0 } = eventOpts;
        e.initUIEvent(event, bubbles, cancelable, target, detail);
        target.dispatchEvent(e);
    }
};

